module.exports = __webpack_public_path__ + "assets/img/22_1305_big.67696493.jpg";